import { Injectable } from '@angular/core';
import { Observable, interval, timer } from 'rxjs';
import { exhaustMap, takeUntil } from 'rxjs/operators';
import { IdentityVerificationFacade } from '../domain/+state/identity-verification.facade';
import { IdVerseStateData } from '../domain/models/identity-verification.model';

@Injectable({
  providedIn: 'root'
})
export class IdVersePollingService {
  constructor(
    private readonly identityVerificationFacade: IdentityVerificationFacade,
  ) { }

  startPolling(intervalMs: number, timeoutMs: number): Observable<IdVerseStateData> {
    const timeout$ = timer(timeoutMs);

    return interval(intervalMs).pipe(
      takeUntil(timeout$),
      exhaustMap(() => this.identityVerificationFacade.refreshIdVerseState(true))
    );
  }
}
